export default __webpack_public_path__ + "static/media/redtiger-premium.94520927.png";